// LICENSE_CODE ZON
'use strict'; /*jslint ts:true, react:true*/
import React, {useContext, useEffect, useMemo, useState} from 'react';
import {Settings_context} from '../settings_ctx';
import {i_card} from '../ui/cards';
// @ts-ignore
import {useTranslation} from 'react-i18next';
// @ts-ignore
import {url2md5} from 'pub_config';
import cn from 'classnames';
import {Cards} from '../ui/cards';
import {On_scroll_animation} from '../shared/on_scroll_animation';
import zcountry from 'zcountry';
import {use_countries} from '../ui/forms/use_countries';
import styles from './you_love_country_vpn.module.less';
import {Editor} from '../../../shared/editor/editor';

interface i_you_love_country_vpn_props {
    country: string;
    title?: string;
    lp_content?: boolean;
}

export const You_love_country_vpn = (props: i_you_love_country_vpn_props)=>{
    const {t} = useTranslation();
    const {theme} = useContext(Settings_context);
    const {countries} = use_countries();
    const curr_country = useMemo(()=>countries.find(el=>
        el.title.toUpperCase()==(props.country||'')?.toUpperCase()),
    [props.country, countries]);
    const adj = zcountry.adj_list[curr_country?.value] ||
        zcountry.extra_adj_list[curr_country?.value] || null;
    const lp_connection_img = <div className={styles.card_lp_img}>
      <img className={cn('lazyload', styles.card_lp_img_icon)} alt="Locations"
        data-src={url2md5('/www/hola/pub/img/locations_logo.png')}/>
    </div>;
    const globe_url = url2md5('/www/hola/pub/img/hola2023/navbar/hola_about.svg');
    const lp_country_img = <div className={styles.card_lp_img}>
      <div className={styles.card_lp_globe}
        style={{backgroundImage: `url(${globe_url})`}}/>
    </div>;
    const cards: i_card[] = [
        {
            id: 'connection',
            title: props.lp_content ? '190+ locations available worldwide'
                : t('locations.hola_pros.connection.title'),
            text: props.lp_content
                ? 'Bypass geo-restrictions and browse from any location'
                : t('locations.hola_pros.connection.text'),
            img_wrapper_cls: styles.card,
            img: props.lp_content ? lp_connection_img
                : <On_scroll_animation key="connection"
                  src="animation/hola_pros_connection.json" size={[335, 206]}
                  animation={[{frames: {from: 50, to: 75}, direction: 1,
                    loop: false}]}
                  cls={styles.card_anim} scroll_to_pos={0.05}/>,
        },
        {
            id: 'devices',
            title: t('locations.hola_pros.devices.title'),
            text: t('locations.hola_pros.devices.text'),
            img_wrapper_cls: styles.card,
            img: <On_scroll_animation key="devices"
              src="animation/hola_pros_devices.json" size={[335, 206]}
              animation={[{frames: {from: 50, to: 75}, direction: 1,
                loop: false}]}
              cls={styles.card_anim} scroll_to_pos={0.05}/>,
        },
        {
            id: 'country',
            title: props.lp_content
                ? 'Join more than 316 million users worldwide!'
                : t('locations.hola_pros.country.title'),
            text: props.lp_content ? 'Hola is trusted by millions worldwide'
                : t('locations.hola_pros.country.text'),
            img_wrapper_cls: styles.card,
            img: props.lp_content ? lp_country_img
                : 'homepage/how_it_works_country.svg',
        },
    ];
    const cards_cls = {
        container: styles.cards_container,
        title: cn(theme.u2, theme.mono, theme.med, theme.color_n700,
            styles.card_title),
        card: styles.card,
        text: cn(theme.p2, theme.reg, styles.card_text),
    };
    return <div className={cn(theme.container, styles.hola_pros,
      props.lp_content && styles.lp_mode)}>
      <h2>{props.title || <>You'll love Hola {adj?.adj} VPN!</>}</h2>
      <Cards cards={cards} cls={cards_cls}/>
    </div>;
};

interface i_you_love_country_vpn_editor_props {
    value: i_you_love_country_vpn_props;
    on_change: (new_val: i_you_love_country_vpn_props)=>void;
    on_cancel: ()=>void;
}

export const You_love_country_vpn_editor = (
    props: i_you_love_country_vpn_editor_props)=>{
    const [state, set_state] = useState<i_you_love_country_vpn_props>(()=>({
        country: props.value?.country ?? '',
        title: props.value?.title ?? '',
        lp_content: props.value?.lp_content ?? false,
    }));
    useEffect(()=>{
        set_state(c=>({...c, ...props.value}));
    }, [props.value]);
    return <Editor
      value={state}
      editors={[
        {key: 'title', label: 'Title', type: 'text'},
        {key: 'lp_content', label: 'LP content', type: 'boolean'},
        {key: 'country', label: 'Country', type: 'text'},
      ]}
      on_change={v=>{
        set_state(v);
        props.on_change(v);
      }}
      on_save={()=>props.on_change(state)}
      on_cancel={props.on_cancel}
    />;
};
